import { render, staticRenderFns } from "./provinceSort.vue?vue&type=template&id=8360cd14&scoped=true&"
import script from "./provinceSort.vue?vue&type=script&lang=js&"
export * from "./provinceSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8360cd14",
  null
  
)

export default component.exports